// extracted by mini-css-extract-plugin
export default {"Wrapper":"PieChartTestReport_Wrapper__V-1or","CompetencesTitle":"PieChartTestReport_CompetencesTitle__V+cSB","ChartWrapper":"PieChartTestReport_ChartWrapper__431nO"};